import { render, staticRenderFns } from "./VerificationCodeDialog.vue?vue&type=template&id=a73a3fca"
import script from "./VerificationCodeDialog.vue?vue&type=script&lang=js"
export * from "./VerificationCodeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports